<template>
    <section class="SortBar">
        <section class="SortBarItems">
            <CurrencySelector :currency="userCurrency" @click="triggerCurrencyChange"/>
            <SortSelector @click="handleShow" @click-outside="handleClickOutside"/>
            <FilterBtn/>
        </section>
        <SortPanel v-if="!isMobile" :show="showSortPanel"/>
    </section>
</template>

<script lang="ts" setup>
import CurrencySelector from './CurrencySelector/CurrencySelector.vue';
import SortSelector from './SortSelector/SortSelector.vue';
import FilterBtn from './FilterBtn/FilterBtn.vue';
import { useCurrency } from '@composables/useCurrency';
import { useLocalizedContent } from '@app/composables/useLocalizedContent';
import SortPanel from './SortPanel/SortPanel.vue';
import {useMobile} from '@composables/useMobile';
import {useMobileModal} from '@composables/useMobileModal';
import SortPanelMobile from './SortPanel/SortPanelMobile/SortPanelMobile.vue';
import {ref, watch} from "vue";

const { isMobile } = useMobile();
const { open: openModal, close: closeModal } = useMobileModal();
const {userCurrency, triggerCurrencyChange} = useCurrency();
const showSortPanel = ref(false);

const handleShow = () => {
    if (isMobile.value) {
        showSortPanel.value = false;
        openModal(SortPanelMobile);
    } else {
        showSortPanel.value = !showSortPanel.value;
    }
};

const handleClickOutside = () => {
    if (showSortPanel.value) {
        showSortPanel.value = false;
    }
};

watch(isMobile, (mobile) => {
    if (mobile) {
        showSortPanel.value = false;
        return;
    }

    closeModal();
});

useLocalizedContent();
</script>

<style scoped lang="scss">
.SortBar {
    display: flex;
    flex-direction: column;
    width: 100%;

    .SortBarItems {
        display: flex;
        justify-content: space-between;
        align-items: center;
        gap: 0.5rem;
        @include PaddingAreas(0.5, 0);

        @include Breakpoint(Medium, Large, ExtraLarge) {
            justify-content: flex-end;
            @include PaddingAreas(0.25, 0);
        }
    }
}
</style>
